<template>
    <div class="row" v-if="show">
        <div class="container">
            <div class="row no-gutters my-3">
                <div class="col-md-6">
                    <button class="btn btn-outline-secondary btn-novel" @click="showSort()" v-if="bookCount > 1">
                        <i class="fas fa-sort"></i>
                        順番変更
                    </button>
                </div>
                <div class="col-md-6 add-novel">
                    <router-link v-if="hasRecent" :to="recentTo" class="btn btn-outline-success btn-novel">
                        {{$filters.truncate($store.state.recent.section_name || '(無題)', 15)}} を編集
                    </router-link>
                    <router-link to="/mypage/book/new/edit" class="btn btn-outline-primary btn-novel"
                        v-if="$store.getters.verifiedUser || $store.getters.isGuest">
                        <i class="fas fa-pen-alt"></i>
                        小説を投稿する
                    </router-link>
                </div>
            </div>
            <ul class="nav nav-tabs nav-fill mb-4">
                <li class="nav-item">
                    <router-link to="/mypage/books" class="nav-link" :class="{active: !$route.params.status || $route.params.status == 'writing'}">
                        執筆中
                        <span class="badge badge-primary badge-pill" v-if="books.writing">{{books.writing.total}}</span>
                    </router-link>
                </li>
                <li class="nav-item">
                    <router-link to="/mypage/books/finished" class="nav-link" :class="{active: $route.params.status == 'finished'}">
                        完結
                        <span class="badge badge-primary badge-pill" v-if="books.finished">{{books.finished.total}}</span>
                    </router-link>
                </li>
                <li class="nav-item">
                    <router-link to="/mypage/books/pending" class="nav-link" :class="{active: $route.params.status == 'pending'}">
                        保留
                        <span class="badge badge-primary badge-pill" v-if="books.pending">{{books.pending.total}}</span>
                    </router-link>
                </li>
            </ul>
            <div class="sticky">
                <page :last_page="status.last_page" v-model="status.current_page" @goto="goto"></page>
            </div>
            <div class="row no-gutters" v-show="!isLoading">
                <div class="col-md-12">
                    <book v-for="v in status.data" :book="v" :key="v.id"></book>
                    <div v-if="!status || !status.total" class="mx-2">
                        <div v-if="bookCount > 0" class="text-center">
                            <span v-if="!$route.params.status">執筆中の</span>
                            <span v-else-if="$route.params.status == 'finished'">完結の</span>
                            <span v-else-if="$route.params.status == 'pending'">保留中の</span>
                            小説はありません。
                        </div>
                        <div v-else-if="$store.getters.verifiedUser || $store.getters.isGuest" class="position-relative text-center mx-auto" style="max-width: 640px;">
                            <img src="/img/write.png" alt="執筆" class="d-block mx-auto my-5">
                            <h4 class="mb-5">
                                最初の小説を書きましょう。
                            </h4>
                            <div class="small text-muted desc">
                                <p>
                                    貸し本棚はページ分けされた長編小説、単一ページの短編小説を執筆することができます。
                                </p>
                                <p>
                                    小説の執筆は簡単です。
                                </p>
                                <p>
                                    作品のタイトルと紹介文を書き、長編か短編を選択すれば。すぐに執筆を開始できます。<br>
                                    執筆画面は小説本文のみが表示され、執筆に集中することができます。
                                </p>
                            </div>
                            <router-link to="/mypage/book/new/edit" class="btn btn-outline-primary">
                                <i class="fas fa-pen-alt"></i>
                                小説を投稿する
                            </router-link>
                        </div>
                        <div v-else class="position-relative text-center mx-auto mt-5 text-danger">
                            メールアドレスを承認してください。
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <sort-books @load="load()"></sort-books>
        <loading
            v-model:active="isLoading"
            :can-cancel="false"
            :is-full-page="true"></loading>
    </div>
</template>

<style scoped lang="scss">
.icon {
    width: 1.3rem;
    height: 1.3rem;
    display: inline-block;
    margin: 0 .5rem;
}
.img-column {
    max-width: 83px;
}
.edit-btn {
    margin: 1em 0 0 0;
}
.badge {
    font-size: .7rem;
}
.btn-novel {
    margin: .25rem;
}
.title {
    display: inline-block;
    margin-bottom: 0;
    font-size: 1.15rem;
}
.card-subtitle {
    font-weight: normal;
    font-size: .7rem;
}
.card {
    overflow: hidden;
}
.btn {
    white-space: nowrap;
}
.btn-novel {
    .btn {
        font-size: .7rem;
    }
}
.add-novel {
    text-align: right;
}
.desc {
    max-width: 480px;
    text-align: left;
    margin: 1rem auto;
}
@media screen and (max-width: 770px) {
    .container {
        padding: 0;
    }
    .nav-tabs {
        .nav-link {
            padding: .3rem .5rem;
            &.active {
                background-color: #eee;
            }
        }
    }
    .add-novel {
        text-align: center;
    }
    .btn-novel {
        display: block;
    }
}
</style>

<script>
import book from "./book";
import sortBooks from "./sortBooks";
import page from "components/Page";
export default {
    components: {
        book,
        page,
        sortBooks,
    },
    data() {
        return {
            books: {},
            isLoading: false,
            show: true,
            page: 1,
        }
    },
    methods: {
        goto(p) {
            this.isLoading = true;
            axios.get("/mypage/books/more", {params: {
                page: p,
                status: this.$route.params?.status || "writing"
            }}).then(res => {
                this.books[this.$route.params?.status || "writing"] = res.data;
            }).catch(err => {
                alert.err(err.response);
            }).finally(() => {
                this.isLoading = false;
            });
        },
        load() {
            this.isLoading = true;
            axios.get("/mypage/books/get").then(res => {
                this.books = res.data;
                this.show = true;
            }).catch(err => {
                alert.err(err);
            }).finally(() => {
                this.isLoading = false;
            });
        },
        saveOrder() {
            axios.post("/mypage/books/sort", {books: this.status}).then(res => {
                this.load();
            }).catch(err => { alert.err(err.response) });
        },
        desc(d) {
            d = this.$filters.wrap(d);
            return this.$filters.truncate(d, 120);
        },
        showSort() {
            $("#sort-books").modal();
        },
    },
    computed: {
        status() {
            if (this.$route.params?.status) {
                if (this.books[this.$route.params.status]) {
                    return this.books[this.$route.params.status];
                }
            }
            // デフォルト
            if (this.books && this.books.writing) {
                return this.books.writing;
            }
            return [];
        },
        bookCount() {
            if (this.books && this.books.writing) {
                return this.books?.writing?.total + this.books?.finished?.total + this.books?.pending?.total;
            }
            return 0;
        },
        hasRecent() {
            if (this.$store.state.recent) {
                return true;
            }
            return false;
        },
        recentTo() {
            if (this.hasRecent) {
                const recent = this.$store.state.recent;
                return `/mypage/book/${recent.book_id}/section/edit/${recent.id}`;
            }
            return "";
        },
    },
    mounted() {
        this.load();
    }
}
</script>